import * as React from "react";
import classnames from "classnames";
/* empty css                       */
import { useProductDetailSlots } from "../../../../slots/slots/context.js";
import { ProductDetailUspItem } from "../../components/ProductDetailUspItem/modules/ProductDetailUsps/components/ProductDetailUspItem/ProductDetailUspItem.js";
const ProductDetailUsps = ({
  items,
  children,
  className
}) => {
  const { Slots } = useProductDetailSlots();
  if ((!items || !items.length) && !Slots.BeforeUsps) return null;
  return /* @__PURE__ */ React.createElement("ul", { className: classnames(className, "product-detail-usps"), "data-t": "product-detail-usps" }, children, Slots.BeforeUsps && /* @__PURE__ */ React.createElement(Slots.BeforeUsps, null), items && items.map((usp) => /* @__PURE__ */ React.createElement(ProductDetailUspItem, { item: usp, key: usp.text })));
};
export {
  ProductDetailUsps
};
//# sourceMappingURL=ProductDetailUsps.js.map
